var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.C_isSystemStatusLoaded)?_c('span',[_c('span',{class:_vm.C_systemStatusClass})]):_vm._e(),_vm._v(" "),(_vm.C_isSystemStatusUnKnown)?_c('span',{staticClass:"c16_system_unknown"}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12cc1c3c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Labels/c16SysOnlineIndicator.vue
// module id = null
// module chunks = 